module.exports = __webpack_public_path__ + "static/media/think.c8841cbc.png";